export const NOTIFICATION = {
  notifications: "Notifications",
  thatsAll: "That's all your notifications from the last 30 days.",
  noNotification: "No notification available.",
}